import { areTimesEqual, roundToMilliseconds } from "@/utils/time.js";

// Main player data store

const state = {
  // is player startes
  isPlaying: true,
  // fast player mode parameters
  fastForward: {
    // is fast mode enabled
    enabled: false,
    // speed factor
    playbackRate: 2
  },
  // current player unix timestamp
  displayTimer: 0,
  initialized: false
};

/** this is all actions we could make with state*/
const mutations = {
  /**
   * Store that player started
   * @param {Object} state Storage state
   */
  ndvrPlay(state) {
    state.isPlaying = true;
  },
  /**
   * Store that player stopped
   * @param {Object} state Storage state
   */
  ndvrPause(state) {
    state.isPlaying = false;
  },
  /**
   * Set player initialized
   * @param {Object} state Storage state
   */
  setInitialized(state, val) {
    state.initialized = val;
  },
  /**
   * Set current player time
   * @param {Object} state Storage state
   * @param {Number} value Current time unix timestamp
   */
  setTimer(state, value) {
    state.displayTimer = roundToMilliseconds(value);
  },
  setShangeCoursourPositinonCalendar(state, value) {
    state.displayTimer = roundToMilliseconds(value);
  },
  setStopPlayerNdvr(state, value) {
    state.isPlaying = value;
  }
};

const actions = {
  /**
   * Update current player time
   * @param {Number} time New time unix timestamp
   */
  updateTimer({ commit, state }, time) {
    if (!areTimesEqual(time, state.displayTimer) && state.initialized) {
      commit("setTimer", time);
    }
  },
  /**
   * Initialize player parameters when it loaded or updated
   * @param {Number} time player time unix timestamp
   */
  initialize({ commit, state }, time) {
    if (!state.initialized && !isNaN(time)) {
      commit("setTimer", time);
      commit("setInitialized", true);
    }
  },
  /**
   * Start NDVR player
   */
  play({ commit }) {
    commit("ndvrPlay");
  },
  /**
   * Stop NDVR player
   */
  pause({ commit }) {
    commit("ndvrPause");
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
